import * as Utils from '../lib/savanna_utils.js';

/**
 * Cache to register v_department_company
 * @kind cache
 * @class ContractTypeLookup
 * @description Custom lookup cache for
 * @usage let lookup = await Grape.cache.get('DepartmentCompanyList');
 */

export default {
	name: 'DepartmentCompanyList',
	options: {
		refresh: async function (cb) {
			try
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					schema: 'savanna',
					table: 'v_department_company',
					limit: 1000, sortfield: 'department',
					sortorder: 'ASC'
				});
				res.records.forEach(r => { r.name = `${r.department} (${r.company})`; });

				cb(null, res.records);
			}
			catch (e)
			{
				cb(e, null);
			}
		}
	}
};
